/* eslint-disable camelcase */
import { User } from 'src/services/user/user.types';
import { invisiblyApi } from '../../../redux/api/invisibly-api';
import { InvisiblyApiResponse } from '../../../services/api/api-response.types';
import { Account, GetAccountsParams, UpdateAccountParams, Campaign, GetCampaignsParams, UpdateCampaignParams } from '../types/client-management.types';

const accountsEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccounts: builder.query<Account[], GetAccountsParams>({
      query: () => ({
        method: 'GET',
        url: 'b2b/manage/accounts',
      }),
      transformResponse(response: InvisiblyApiResponse<Account[]>) {
        return response.item;
      },
      // providesTags: ['Account'],
    }),
    updateAccount: builder.mutation<Account, UpdateAccountParams>({
      query: ({ accountId, ...updateData }) => ({
        method: 'PATCH',
        url: `b2b/manage/accounts/${accountId}`,
        data: updateData,
      }),
      transformResponse(response: InvisiblyApiResponse<Account>) {
        return response.item;
      },
      // invalidatesTags: ['Account'],
    }),
    getCampaigns: builder.query<Campaign[], GetCampaignsParams>({
      query: () => ({
        method: 'GET',
        url: 'b2b/manage/campaigns',
      }),
      transformResponse(response: InvisiblyApiResponse<Campaign[]>) {
        return response.item;
      },
      // providesTags: ['Campaign'],
    }),
    updateCampaign: builder.mutation<Campaign, UpdateCampaignParams>({
      query: ({ campaignId, ...updateData }) => ({
        method: 'PATCH',
        url: `b2b/manage/campaigns/${campaignId}`,
        data: updateData,
      }),
      transformResponse(response: InvisiblyApiResponse<Campaign>) {
        return response.item;
      },
      // invalidatesTags: ['Campaign'],
    }),
    getInternalUsers: builder.query<User[], void>({
      query: () => ({
        method: 'GET',
        url: 'b2b/manage/users',
      }),
      transformResponse(response: InvisiblyApiResponse<User[]>) {
        return response.item;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAccountsQuery,
  useUpdateAccountMutation,
  useGetCampaignsQuery,
  useUpdateCampaignMutation,
  useGetInternalUsersQuery,
} = accountsEndpoints;
